import type { NodeModel } from './tree-types';

export function createItem<T>(props: Omit<NodeModel<T>, 'droppable' | 'text'> & { text?: string }): NodeModel<T> {
  return {
    droppable: true,
    text: '',
    ...props,
  };
}

export function getChildren<T>(tree: NodeModel<T>[], nodeId: NodeModel<T>['id']) {
  return tree.filter(({ parent }) => parent === nodeId);
}

export function hasChildren<T>(tree: NodeModel<T>[], nodeId: NodeModel<T>['id']) {
  return tree.some(({ parent }) => parent === nodeId);
}

/** The node with `nodeId`, or `undefined` when the tree does not hold it. */
export function getTreeItem<T>(tree: NodeModel<T>[], nodeId: NodeModel<T>['id']) {
  return tree.find(({ id }) => id === nodeId);
}

/** Every node below `nodeId`, depth-first and flattened — children, their children, and so on. */
export function getDescendants<T>(tree: NodeModel<T>[], nodeId: NodeModel<T>['id']): NodeModel<T>[] {
  return getChildren(tree, nodeId).flatMap((child) => [child, ...getDescendants(tree, child.id)]);
}

/** Whether `nodeId` sits anywhere below `ancestorId`, however deep. */
export function isDescendant<T>(
  tree: NodeModel<T>[],
  ancestorId: NodeModel<T>['id'],
  nodeId: NodeModel<T>['id']
): boolean {
  return getDescendants(tree, ancestorId).some(({ id }) => id === nodeId);
}
